import React from "react";
import { ProductAd } from "~/common/Store/models/ProductPage";
import useProductTracking from "../Gtm/useProductAdTracking";

interface Props {
  ads: ProductAd[];
  isExpandedDescriptionTemplate?: boolean;
}

const ProductDetailProductAds = ({
  ads,
  isExpandedDescriptionTemplate = false,
}: Props) => {
  const bottomMargin: React.CSSProperties = {
    marginBottom: "10px",
  };
  const containerRef = React.useRef<HTMLDivElement>(null);

  useProductTracking(containerRef);

  return isExpandedDescriptionTemplate ? (
    <div ref={containerRef} className="mt-3 lt:mt-0">
      {ads.map((ad) => (
        <div
          id={ad.id.toString()}
          style={bottomMargin}
          className="ads gtm-promo p-2 xs:p-0 adContainer flex justify-center"
          data-testid="expanded-adscontainer"
          key={ad.id}
          dangerouslySetInnerHTML={{ __html: ad.rawHtml }}
        />
      ))}
    </div>
  ) : (
    <div
      id="SHQ-ads-1"
      ref={containerRef}
      className="ads feature"
      data-testid="adscontainer"
    >
      {ads.map((ad) => (
        <div
          key={ad.id}
          id={ad.id.toString()}
          className="adContainer"
          dangerouslySetInnerHTML={{ __html: ad.rawHtml }}
        />
      ))}
    </div>
  );
};

export default ProductDetailProductAds;
